import React, { useEffect, useContext, useState }  from 'react'
import { View, StyleSheet, ScrollView, KeyboardAvoidingView } from 'react-native'
import { Button, Text, Spinner, Radio } from '@ui-kitten/components'
import StyledTextInput from '../../components/StyledTextInput'
import { UserContext } from '../../global/UserProvider'
import { saveWallets, deleteWallet, checkIdUniquenes } from '../../global/Firebase/firebase'
import HeaderIconButton from '../../components/HeaderIconButton'
import * as Sentry from "@sentry/react-native"
import { useTranslation } from 'react-i18next'
import { constantsAtom, storesDictAtom } from '../../global/AtomsProvider'
import { useAtomValue } from 'jotai'
import { sanitizeForFirestore } from '../../global/Firebase/productSanitize'

export default function WalletDetailScreen( { navigation, route } ) {
  const { t } = useTranslation()
  const [context, setContext] = useContext(UserContext)
  const storesDict = useAtomValue(storesDictAtom)
  const constants = useAtomValue(constantsAtom)
  const { detail, detailIndex, allData } = route.params
  const [id, setId] = useState(detail ? (detail.id || '') : ('wallet-' + Date.now()))
  const [text, setText] = useState(detail ? (detail.text || '') : '')
  const [storeId, setStoreId] = useState(detail && detail.storeId ? detail.storeId : '')
  const [saveError, setSaveError] = useState('')
  const [successMessageVisible, setSuccessMessageVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  
  // Emit detail data for E2E testing
  useEffect(() => {
    if (detail?.id) {
      console.log('[WALLET_DETAIL_DATA]', JSON.stringify(sanitizeForFirestore({
        id: detail.id,
        text: detail.text,
        storeId: detail.storeId || '',
      })));
    }
  }, [detail]);

  useEffect(() => {
    navigation.setOptions({
      headerRight: () => (
        <HeaderIconButton
          onPress={() => {
            let walletTiedToPaymentMethod = false
            let paymentMethodsList = ''
            for (let paymentMethod of constants.paymentMethods.data) {
              Object.entries(storesDict).forEach(([key, value]) => {
                if (paymentMethod.destinationWalletForStore[key]?.id === detail.id) {
                  walletTiedToPaymentMethod = true
                  paymentMethodsList += paymentMethod.name + ', '
                }
              })
            }
            if (walletTiedToPaymentMethod) {
              alert(t('settings.walletTiedToPaymentMethodError', { paymentMethods: paymentMethodsList }))
              setIsLoading(false)
              return
            }
            deleteWallet(context.db, detailIndex, allData)
            navigation.goBack()
          }}
          iconName='trash-outline'
        />
      ),
      title: (detail?.name || '')
    })
  }, [])

  async function save() {
    setIsLoading(true)
    let uniqueId = true
    if (detailIndex == allData.length) {
      uniqueId = checkIdUniquenes(id, constants)
    }
    if (text !== '' && id !== '' && uniqueId) {
      setSaveError('')
      let info = {
        text,
        id,
        storeId: storeId || null,
      }
      try {
        await saveWallets(context.db, info, detailIndex, allData)
        setSuccessMessageVisible(true)
        setIsLoading(false)
      } catch (error) {
        Sentry.captureException(error)
        console.log(error)
        setSaveError(t('error'))
        setIsLoading(false)
      }
    } else if (uniqueId) {
      setSaveError(t('notAllFieldsFilled'))
      setIsLoading(false)
    } else {
      setSaveError(t('settings.uniqueIdError'))
      setIsLoading(false)
    }
  }

  

  return (
    <KeyboardAvoidingView style={{flex: 1}} behavior="height" keyboardVerticalOffset = {100}>
      <ScrollView style={styles.container} keyboardShouldPersistTaps='handled' keyboardDismissMode='on-drag'>
        {detail && <Text appearance='hint' style={{textAlign: 'center'}}>
          {detail.id}
        </Text>}
    
        <Text category='label' style={styles.label}>
          {t('settings.name')}
        </Text>
        <StyledTextInput 
          value={text}
          onChangeText={text => setText(text)}
          returnKeyType='done'
          autoCapitalize='sentences'
        />
        <Text category='label' style={styles.label}>{t('store')}</Text>
        <Radio testID="radio-common" style={styles.radio} checked={storeId === ''} onChange={() => {setStoreId('')}}>
          {t('settings.commonBetweenStores')}
        </Radio>
        { Object.values(storesDict).map((item, index) => (
          <Radio testID={`radio-store-${index}`} key={item.id} style={styles.radio} checked={storeId === item.id} onChange={() => {setStoreId(Object.values(storesDict)[index].id)}}>
            {item.name}
          </Radio>
        ))}
        
        {saveError != '' && (
          <Text category='p1' status='danger' style={styles.label}>
            {saveError}
          </Text>
        )}
        { successMessageVisible && (
          <>
          <Text status='success'>{t('success')}</Text>
          <Button onPress={() => navigation.goBack()} style={styles.submitButton}>
            {t('back')}
          </Button>
          </>
        )}
        {isLoading ? (
          <View style={styles.spinner}><Spinner /></View>
        ) : (
          !successMessageVisible && (
          <Button onPress={save} style={styles.submitButton}>
            {t('save')}
          </Button>
          )
        )}
        <View style={{height: 100}}></View>
      </ScrollView>
    </KeyboardAvoidingView>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
  },

  label: {
    marginBottom: 8,
    marginTop: 16,
  },
  submitButton: {
    marginTop: 16,
  },
  spinner: {
    marginTop: 15,
    alignItems: 'center'
  },
  radio: {
    marginBottom: 5
  },
});